import React from 'react';
import PropTypes from 'prop-types';
import { Visible, Spacer } from '@tfecom-thermofisher/react-komodo-design';

import successPlateImg from 'src/assets/images/success_plate.svg';
import { Icon, Button } from 'src/core/components';

import messages from './messages';
import './Plates.style.scss';

const Plate = ({ plate, removePlate, editPlate }) => (
  <>
    <Spacer top={10} />
    <div className="dna-plate">
      <div className="dna-plate__row">
        <div className="dna-plate__row-edit" onClick={editPlate}>
          <Visible when={!plate?.isValid}>
            <Icon name="warning-bold" size={24} color="red" />
          </Visible>
          <Visible when={plate?.isValid}>
            <img width={24} height={24} src={successPlateImg} alt="success_plate" />
          </Visible>
          <Spacer right={11} />
          <div className="dna-plate__name">{plate?.plateName}</div>
          <Spacer right={24} />
        </div>
        <Button
          data-testid="edit-plate-button"
          className="dna-plate__action"
          type="tertiary"
          label={messages.edit}
          onClick={editPlate}
        />
        <Spacer right={10} />
        <div className="dna-plate__action-divider" />
        <Spacer right={10} />
        <Button
          data-testid="remove-plate-button"
          className="dna-plate__action"
          type="tertiary"
          label={messages.remove}
          onClick={removePlate}
        />
      </div>
    </div>
  </>
);

Plate.propTypes = {
  plate: PropTypes.object,
  removePlate: PropTypes.func.isRequired,
  editPlate: PropTypes.func.isRequired
};

export default Plate;
